/**
 * Suffix helper
 *
 */

import { createContext, isValidElement } from 'react'
import type { HTMLAttributes, ReactNode } from 'react'
import clsx from 'clsx'
import { createSkeletonClass } from '../../components/skeleton/SkeletonHelper'
import type { SkeletonShow } from '../../components/skeleton/Skeleton'

const SuffixContext = createContext(null)

export type SuffixChildren = ReactNode

export type SuffixProps = {
  className: string
  children: SuffixChildren
  context: Record<string, unknown>
  skeleton?: SkeletonShow
}

const Suffix = ({
  className,
  children,
  context,
  skeleton,
  ...props
}: SuffixProps & HTMLAttributes<HTMLSpanElement>) => {
  const content = (
    // The styles are as of now, set in @dnb/eufemia/src/style/components/imports.scss
    <span
      className={clsx(
        'dnb-suffix',
        !isValidElement(children) &&
          createSkeletonClass('font', skeleton, context),
        className
      )}
      {...props}
    >
      {children}
    </span>
  )

  if (typeof children !== 'string' && context) {
    return <SuffixContext value={context}>{content}</SuffixContext>
  }

  return content
}

export { SuffixContext }

export default Suffix
